const setSessionParam = (paramName, paramValue) => {
  sessionStorage.setItem(paramName, paramValue);
}

const getSessionParam = (paramName) => {
  let param = sessionStorage.getItem(paramName);

  return param ? param : null;
}

const getUserId = () => {
  return document.querySelector('body').getAttribute('data-user-id');
}

export const userAddPaymentInfo = (currencyCode, paddleCustomerId, paymentMethod) => {
  if (!window.dataLayer) return;

  const userId = getUserId();

  const eventProperties = {
    'user_id': (userId === 0 || userId === '0') ? null : userId,
    'page_id': document.querySelector('body').getAttribute('data-page-id'),
    'currency_code': currencyCode,
    'paddle_customer_id': paddleCustomerId,
    'payment_method': paymentMethod,
    'utm_source': getSessionParam('utm_source'),
    'utm_medium': getSessionParam('utm_medium'),
    'utm_campaign': getSessionParam('utm_campaign'),
  }

  if (window.gtag) {
    gtag('event', 'user_add_payment_info', eventProperties);
  }

  /*if (window.amplitude) {
    window.amplitude.track('user_add_payment_info_amp', eventProperties);
  }*/
}

export const userAddToCart = (membershipType) => {
  const userId = getUserId();

  const eventProperties = {
    'page_id': document.querySelector('body').getAttribute('data-page-id'),
    'membership_type': membershipType.toLowerCase().replace(' ', '-'),
    'user_id': (userId === 0 || userId === '0') ? null : userId,
    'utm_source': getSessionParam('utm_source'),
    'utm_medium': getSessionParam('utm_medium'),
    'utm_campaign': getSessionParam('utm_campaign'),
  }

  if (window.gtag) {
    gtag('event', 'user_add_to_cart', eventProperties);
  }

  /*if (window.amplitude) {
    window.amplitude.track('user_add_to_cart_amp', eventProperties);
  }*/
}

export const userInitiateCheckout = (membershipType, isTrial) => {
  const userId = getUserId();

  const eventProperties = {
    'page_id': document.querySelector('body').getAttribute('data-page-id'),
    'membership_type': membershipType.toLowerCase().replace(' ', '-'),
    'user_id': (userId === 0 || userId === '0') ? null : userId,
    'is_trial': isTrial,
    'utm_source': getSessionParam('utm_source'),
    'utm_medium': getSessionParam('utm_medium'),
    'utm_campaign': getSessionParam('utm_campaign'),
  }

  if (window.gtag) {
    gtag('event', 'user_initiate_checkout', eventProperties);
  }

  /*if (window.amplitude) {
    window.amplitude.track('user_initiate_checkout_amp', eventProperties);
  }*/
}

export const userCompletePayment = (membershipType, isTrial, paddleCustomerId, paymentMethod, currencyCode) => {
  const userId = getUserId();

  const eventProperties = {
    'page_id': document.querySelector('body').getAttribute('data-page-id'),
    'membership_type': membershipType.toLowerCase().replace(' ', '-'),
    'user_id': (userId === 0 || userId === '0') ? null : userId,
    'is_trial': isTrial,
    'start_date': new Date().toISOString(),
    'paddle_customer_id': paddleCustomerId,
    'payment_method': paymentMethod,
    'currency_code': currencyCode,
    'utm_source': getSessionParam('utm_source'),
    'utm_medium': getSessionParam('utm_medium'),
    'utm_campaign': getSessionParam('utm_campaign'),
  }

  if (window.gtag) {
    gtag('event', 'user_complete_payment', eventProperties);
  }

  /*if (window.amplitude) {
    window.amplitude.track('user_complete_payment_amp', eventProperties);
  }*/
}

export const pageView = () => {
  const userId = getUserId();
  const pageID = document.querySelector('body').getAttribute('data-page-id');

  const searchParams = new URLSearchParams(window.location.search);

  if (searchParams.get('utm_source')) {
    setSessionParam('utm_source', searchParams.get('utm_source'))
  }

  if (searchParams.get('utm_medium')) {
    setSessionParam('utm_medium', searchParams.get('utm_medium'))
  }

  if (searchParams.get('utm_campaign')) {
    setSessionParam('utm_campaign', searchParams.get('utm_campaign'))
  }

  const eventProperties = {
    'app_name': 'FitXR web',
    'user_id': (userId === 0 || userId === '0') ? null : userId,
    'user_ipaddress': document.querySelector('body').getAttribute('data-user-ip'),
    'page_id': pageID,
    'utm_source': getSessionParam('utm_source'),
    'utm_medium': getSessionParam('utm_medium'),
    'utm_campaign': getSessionParam('utm_campaign'),
    'is_landing_page': ['11', '689', '138', '140', '128', '130'].includes(pageID),
  }

  if (window.gtag) {
    gtag('event', 'page_view', eventProperties)
  }

  /*if (window.amplitude) {
    window.amplitude.track('page_view_amp', eventProperties);
  }*/
}

export const userRegisteredDetails = (checkoutData) => {
  const userId = getUserId();

  const eventProperties = {
    'first_name': checkoutData.billing_first_name,
    'last_name': checkoutData.billing_last_name,
    'user_id': (userId === 0 || userId === '0') ? null : userId,
    'state': checkoutData.billing_state,
    'city': checkoutData.billing_city,
    'country': checkoutData.billing_country,
    'postcode': checkoutData.billing_postcode,
    'utm_source': getSessionParam('utm_source'),
    'utm_medium': getSessionParam('utm_medium'),
    'utm_campaign': getSessionParam('utm_campaign'),
  }

  if (window.gtag) {
    gtag('event', 'user_register_details', eventProperties)
  }

  /*if (window.amplitude) {
    window.amplitude.track('user_register_details_amp', eventProperties)
  }*/
}

export const userSignup = (serializedData, data) => {

  const eventProperties = {
    'app_name': 'FitXR web',
    'email': serializedData.email,
    'phone_number': serializedData.tel,
    'has_opted_in_for_updates': serializedData.receive_updates === 'on',
    'has_accepted_privacy_policy': serializedData.accept_terms === 'on',
    'user_id': data.user_id,
    'utm_source': getSessionParam('utm_source'),
    'utm_medium': getSessionParam('utm_medium'),
    'utm_campaign': getSessionParam('utm_campaign'),
  }

  if (window.gtag) {
    gtag('event', 'user_signup', eventProperties)
  }

  /*if (window.amplitude) {
    window.amplitude.track('user_signup_amp', eventProperties)
  }*/
}

export const gtagUserLogin = () => {

  const eventProperties = {
    'app_name': 'FitXR web',
    'email': document.querySelector('input[type="email"]').value,
    'utm_source': getSessionParam('utm_source'),
    'utm_medium': getSessionParam('utm_medium'),
    'utm_campaign': getSessionParam('utm_campaign'),
  }

  if (window.gtag) {
    gtag('event', 'user_login', eventProperties)
  }

  /*if (window.amplitude) {
    window.amplitude.track('user_login_amp', eventProperties)
  }*/
}

export const gtagCancelSubscription = (price, currentSubscription, isTrialingSubscription, userId) => {

  const eventProperties = {
    'app_name': 'FitXR web',
    'membership_type': price.price.description.toLowerCase().replace(' ', '-'),
    'is_trial': isTrialingSubscription,
    'start_date': currentSubscription.started_at,
    'end_date': currentSubscription.next_billed_at,
    'paddle_customer_id': currentSubscription.customer_id,
    'user_id': userId,
    'utm_source': getSessionParam('utm_source'),
    'utm_medium': getSessionParam('utm_medium'),
    'utm_campaign': getSessionParam('utm_campaign'),
  }

  if (window.gtag) {
    gtag('event', 'user_cancelled_subscription', eventProperties)
  }

  /*if (window.amplitude) {
    window.amplitude.track('user_cancelled_subscription_amp', eventProperties)
  }*/
}

export const gtagButtonClick = (id) => {
  const userId = getUserId();

  const eventProperties = {
    'button_id': id,
    'page_id': document.querySelector('body').getAttribute('data-page-id'),
    'user_ipaddress': document.querySelector('body').getAttribute('data-user-ip'),
    'user_id': (userId === 0 || userId === '0') ? null : userId,
    'utm_source': getSessionParam('utm_source'),
    'utm_medium': getSessionParam('utm_medium'),
    'utm_campaign': getSessionParam('utm_campaign'),
  }

  if (window.gtag) {
    gtag('event', 'button_click', eventProperties)
  }

  /*if (window.amplitude) {
    window.amplitude.track('button_click_amp', eventProperties)
  }*/
}

export const gtagUserError = (errorCodes) => {
  const userId = getUserId();

  const eventProperties = {
    'page_id': document.querySelector('body').getAttribute('data-page-id'),
    'user_ipaddress': document.querySelector('body').getAttribute('data-user-ip'),
    'user_id': (userId === 0 || userId === '0') ? null : userId,
    'error_codes': errorCodes,
    'utm_source': getSessionParam('utm_source'),
    'utm_medium': getSessionParam('utm_medium'),
    'utm_campaign': getSessionParam('utm_campaign'),
  }

  if (window.gtag) {
    gtag('event', 'user_error', eventProperties)
  }

  /*if (window.amplitude) {
    window.amplitude.track('user_error_amp', eventProperties)
  }*/
}

export const gtagUserUpdateSubscription = (data, status) => {
  const userId = getUserId();

  const eventProperties = {
    'page_id': document.querySelector('body').getAttribute('data-page-id'),
    'user_ipaddress': document.querySelector('body').getAttribute('data-user-ip'),
    'user_id': (userId === 0 || userId === '0') ? null : userId,
    'action': status,
    'paddle_customer_id': data.current_subscription.customer_id,
    'start_date': data.current_subscription.current_billing_period.starts_at,
    'end_date': data.current_subscription.current_billing_period.ends_at,
    'utm_source': getSessionParam('utm_source'),
    'utm_medium': getSessionParam('utm_medium'),
    'utm_campaign': getSessionParam('utm_campaign'),
  }

  if (window.gtag) {
    gtag('event', 'user_updated_subscription', eventProperties)
  }

  /*if (window.amplitude) {
    window.amplitude.track('user_updated_subscription_amp', eventProperties);
  }*/
}


export const gtagSelectedCookies = (analyticsAccepted, marketingAccepted) => {
  const userId = getUserId();

  const eventProperties = {
    'page_id': document.querySelector('body').getAttribute('data-page-id'),
    'user_ipaddress': document.querySelector('body').getAttribute('data-user-ip'),
    'user_id': (userId === 0 || userId === '0') ? null : userId,
    'analytics_accepted': analyticsAccepted,
    'marketing_accepted': marketingAccepted,
    'utm_source': getSessionParam('utm_source'),
    'utm_medium': getSessionParam('utm_medium'),
    'utm_campaign': getSessionParam('utm_campaign'),
  }

  if (window.gtag) {
    gtag('event', 'user_consent_selection', eventProperties)
  }

  /*if (window.amplitude) {
    window.amplitude.track('user_consent_selection_amp', eventProperties)
  }*/
}
